module.exports = __webpack_public_path__ + "img/person.cf600623.svg";